import { RouteType } from "..";
import { Implantacao } from "../../pages/implantacao/Implantacao";

export const implantacaoRoute: RouteType = {
  id: "AcSk014",
  path: "/processos/implantacao/",
  name: "Implantação",
  component: Implantacao,
};
